/* Firebird "Paint to Order" badge: gentle ribbon flutter (Oct 2026).
   Only the lower ribbon moves; the gold medallion stays still. Each badge flutters on its
   own random timer, so a page full of badges never moves in step. Only badges on screen
   animate. Nothing moves for visitors who ask for reduced motion. If anything fails, the
   plain badge image simply stays as it is. */
(function () {
  if (window.fbPtoFlap) return;
  window.fbPtoFlap = true;
  if (!window.requestAnimationFrame || !window.IntersectionObserver) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Medallion (as fractions of the image), measured from fb-pto-badge-v2.webp
  var MED = { cx: 0.4875, cy: 0.462, rx: 0.289, ry: 0.281 };
  var shared = null; // weights + pixel list, built once from the first image

  function smooth(a, b, v) { var t = Math.min(1, Math.max(0, (v - a) / (b - a))); return t * t * (3 - 2 * t); }

  function buildShared(W, H) {
    var idx = [], wts = [];
    for (var y = 0; y < H; y++) {
      var wy = smooth(0.52 * H, 0.98 * H, y);            // more movement towards the bottom edge
      if (!wy) continue;
      for (var x = 0; x < W; x++) {
        var dx = (x / W - MED.cx) / MED.rx, dy = (y / H - MED.cy) / MED.ry;
        var e = Math.sqrt(dx * dx + dy * dy);             // 1 = medallion edge
        var wm = smooth(1.02, 1.22, e);                   // medallion and its rim stay still
        var w = wy * wm;
        if (w > 0.01) { idx.push(y * W + x); wts.push(w); }
      }
    }
    return { W: W, H: H, idx: new Uint32Array(idx), wts: new Float32Array(wts) };
  }

  function setup(img) {
    if (img.dataset.fbFlap) return;
    img.dataset.fbFlap = '1';
    var go = function () {
      try {
        var W = img.naturalWidth, H = img.naturalHeight;
        if (!W) return;
        var cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var ctx = cv.getContext('2d');
        ctx.drawImage(img, 0, 0, W, H);
        var src = ctx.getImageData(0, 0, W, H);           // throws if the image is cross-origin
        if (!shared || shared.W !== W || shared.H !== H) shared = buildShared(W, H);
        var out = ctx.createImageData(W, H);
        cv.className = 'fb-pto-flap';
        cv.setAttribute('role', 'img');
        cv.setAttribute('aria-label', img.alt || 'Paint to Order');
        img.parentNode.insertBefore(cv, img);
        img.style.display = 'none';
        badges.push({
          cv: cv, ctx: ctx, src: src.data, out: out, W: W, H: H,
          visible: false, start: 0, dur: 0,
          next: performance.now() + 800 + Math.random() * 5000,
          phase: Math.random() * 6.283, speed: 0.8 + Math.random() * 0.5, still: true
        });
        io.observe(cv);
        cv._fb = badges[badges.length - 1];
        kick();
      } catch (e) { img.style.display = ''; }
    };
    if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
  }

  function draw(b, t) {
    var p = (t - b.start) / b.dur;
    var s = b.src, o = b.out.data, W = b.W, H = b.H;
    if (p >= 1) {                                         // flutter finished: rest until the next one
      if (!b.still) { o.set(s); b.ctx.putImageData(b.out, 0, 0); b.still = true; }
      b.next = t + 4000 + Math.random() * 8000;
      b.start = 0;
      return;
    }
    var env = Math.sin(Math.PI * p);                      // ease in and out
    var A = 0.03 * H * env;                               // gentle: about 3% of the badge height
    var k = 6.283 / (0.55 * W), wt = (t / 1000) * 6.283 * 1.3 * b.speed + b.phase;
    o.set(s);
    var idx = shared.idx, wts = shared.wts;
    for (var n = 0; n < idx.length; n++) {
      var i = idx[n], y = (i / W) | 0, x = i - y * W;
      var d = A * wts[n] * Math.sin(k * x - wt);
      var sy = y - d, y0 = Math.floor(sy), f = sy - y0, y1 = y0 + 1;
      var q = i * 4;
      if (y0 < 0 || y1 >= H) { o[q + 3] = 0; continue; }
      var a = (y0 * W + x) * 4, c = (y1 * W + x) * 4, g = 1 - f;
      o[q] = s[a] * g + s[c] * f; o[q + 1] = s[a + 1] * g + s[c + 1] * f;
      o[q + 2] = s[a + 2] * g + s[c + 2] * f; o[q + 3] = s[a + 3] * g + s[c + 3] * f;
    }
    b.ctx.putImageData(b.out, 0, 0);
    b.still = false;
  }

  var badges = [], running = false, lastStart = -1e9;
  var io = new IntersectionObserver(function (entries) {
    var now = performance.now();
    entries.forEach(function (e) {
      var b = e.target._fb; if (!b) return;
      // Coming into view: pick a fresh random wait, so badges scrolled in together don't start together
      if (e.isIntersecting && !b.visible && !b.start) b.next = now + 600 + Math.random() * 6000;
      b.visible = e.isIntersecting;
    });
    kick();
  });

  function tick(t) {
    var any = false;
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (!b.visible || !b.cv.isConnected) continue;
      any = true;
      if (!b.start && t >= b.next) {
        // Never start within 1.4s of another badge: wait a little longer instead
        if (t - lastStart < 1400) { b.next = t + 400 + Math.random() * 2500; }
        else { lastStart = t; b.start = t; b.dur = 1800 + Math.random() * 1200; b.phase = Math.random() * 6.283; }
      }
      if (b.start) draw(b, t);
    }
    if (any && !document.hidden) requestAnimationFrame(tick); else running = false;
  }
  function kick() { if (!running) { running = true; requestAnimationFrame(tick); } }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

  function scan() {
    // Copies made by the phone photo carousel carry a blank canvas: reset them to the plain image
    var cvs = document.querySelectorAll('.fb-pto-badge canvas.fb-pto-flap');
    for (var j = 0; j < cvs.length; j++) {
      if (cvs[j]._fb) continue;
      var im = cvs[j].nextElementSibling;
      cvs[j].parentNode.removeChild(cvs[j]);
      if (im && im.tagName === 'IMG') { im.style.display = ''; delete im.dataset.fbFlap; }
    }
    var imgs = document.querySelectorAll('.fb-pto-badge img');
    for (var i = 0; i < imgs.length; i++) setup(imgs[i]);
  }
  var queued = false;
  function queueScan() { if (queued) return; queued = true; setTimeout(function () { queued = false; scan(); }, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
